import type { ShopperReservationMode } from '@iheartjane/types';

// reservation_mode + pickup sub-mode → top-level toggle value. With
// `availableModes`, clamps to it (an unavailable curbside prefers pickup and
// vice versa) so the toggle never points at an unrendered mode; falls through
// to the first available mode when neither side of that pair is available.
// Omit `availableModes` for the raw desired mode.
export const resolveSelectedMode = (
  reservationMode: string | undefined,
  pickupSubMode: string | undefined,
  availableModes?: readonly ShopperReservationMode[]
): ShopperReservationMode => {
  const desired: ShopperReservationMode =
    reservationMode === 'delivery'
      ? 'delivery'
      : pickupSubMode === 'curbside'
        ? 'curbside'
        : 'pickup';

  if (!availableModes || availableModes.includes(desired)) return desired;

  if (desired === 'curbside' && availableModes.includes('pickup')) {
    return 'pickup';
  }

  if (desired === 'pickup' && availableModes.includes('curbside')) {
    return 'curbside';
  }

  return availableModes[0] ?? desired;
};
